import { IconButton, Menu} from '@material-ui/core';
import React, { useState } from 'react';
import { FilterProperties } from 'Shared/components/PagedView/Filter';
import 'Shared/components/PagedView/Table/ColumnHeader.sass';
import 'Shared/components/PagedView/Table/TableFilterMenu.sass';
import { getIsFilterAppliedForColumn } from 'Shared/components/PagedView/Table/TableHeader';
import { toKebabCase } from 'Shared/utilities/stringFormatHelpers';

type TableFilterButtonProps = {
  FilterComponent: JSX.Element;
  title: string;
  filterProperties: FilterProperties<any>;
  titleOrType?: string;
};

const TableFilterMenu = (props: TableFilterButtonProps) => {
  const [filterMenuAnchor, setFilterMenuAchor] = useState<HTMLElement | false>(false);

  return (
    <>
      <IconButton
        id={`column-filter-btn-${toKebabCase(props.title)}`}
        className="column-header__filter-icon"
        size="small"
        color={getIsFilterAppliedForColumn(props.filterProperties) ? 'primary' : 'default'}
        onClick={e => setFilterMenuAchor(e.currentTarget)}
        aria-label={`${props.title} filter icon`}
        aria-haspopup={true}
      >
        <i className="fa fa-filter" />
      </IconButton>
      <Menu
        classes={{paper: 'table-filter-menu'}}
        anchorEl={filterMenuAnchor || undefined}
        onClose={() => setFilterMenuAchor(false)}
        open={Boolean(filterMenuAnchor)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        getContentAnchorEl={null}
        aria-label={`${props.title} filter menu`}
      >
        {props.FilterComponent}
      </Menu>
    </>
  );
};

export default TableFilterMenu;
